<template>
  <div class="cmp-distribution-shop_groups-shop_group_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddShopGroupsClick"
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            alt
          />
        </div>
      </div>
    </div>

    <div class="dt-page--body">
      <NTable
        id="distribution-shop_groups-shop_group_list"
        class="h1"
        :config="tableConfig"
        :headers="headers"
        :items="list"
        @scrollnext="onListScroll"
        :loadingFlag="loadingFlag"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr
            :class="{
              selected: selectedRow(item)
            }"
            @click="onRowClicked(item)"
            :title="'Click to see Shop_Group List'"
          >
            <td v-bind="tdcon('shop_groups_name')">
              <span class="txtov" :title="item['shop_group_name']">{{
                item["shop_group_name"]
              }}</span>
            </td>
            <!-- <td
              v-bind="tdcon('cost_income_group')"
              :title="item['file_id'] ? '' : 'Upload Documents'"
            ></td> -->
            <!-- item["channel"] ? item["channel"] : null -->
            <td v-bind="tdcon('channel')">
              <span class="txtov" :title="item['channel']">{{
                item["channel"]
              }}</span>
            </td>
            <td v-bind="tdcon('shop_group_type')">
              <span class="txtov" :title="item['group_type']">{{
                $dft.capHead($t(item["group_type"]).slice(11, 18))
              }}</span>
            </td>
            <td v-bind="tdcon('shops')">
              <span class="txtov" :title="item['shops']">{{
                item["shops"]
              }}</span>
            </td>
            <td v-bind="tdcon('options')">
              <img
                src="static/icons/delete.svg"
                @click.stop="e => onShopGroupDelete(item)"
                class="dt-icon v5 s2 ut-center"
                alt
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>

    <Sidewindow
      :navConfig="defaultConfig"
      :value="shopGroupsDetailsFlag"
      @closed="onCloseShopGroupsDetails"
    >
      <ShopGroupsSidewindow />
    </Sidewindow>

    <ModalContainer :modalKey="'addShopGroup'" :width="'small'">
      <AddShopGroup
        :list="list"
        @cancelled="onDialogCancelled"
        @added="onAddedShopGroup"
      />
    </ModalContainer>
  </div>
</template>

<script>
import NTable from "@/plugins/datatable/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";
import * as ActionTypes from "../../store/types";
import { DistributionStoreNamespace as storeNS } from "../../store";
import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import {
  closeModalRoute,
  createModalMixin
} from "../../../../dt-plugins/modal/modal.mixin";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { shop_groupsDistributionGetters } from "../../store/shop_groups/getters";
import { shop_groupsDistributionActions } from "../../store/shop_groups/actions";
import {
  distributionShop_groupListLDTRoutes,
  getDistributionShop_groupDetailsSelectable
} from "../../router/routes";
import {
  childOfOrEqualDetails,
  handleFromRoute
} from "../../../../utility/route";
import {
  createLDTHost,
  defaultConfig
} from "../../../../dt-plugins/sidewindow";

import ShopGroupsSidewindow from "./shop_groups-sidewindow";
import { async } from "rxjs/internal/scheduler/async";
import { forEach } from "ramda";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";

import AddShopGroup from "./add_shop-group";
import { Shop_groupsService } from "../../services/shop_groups.service";

const LDTConfig = {
  entityName: "shop_group",
  ldtRoutes: distributionShop_groupListLDTRoutes,
  detailsSelectableFunction: getDistributionShop_groupDetailsSelectable,
  primaryKey: "shop_group_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.Shop_groupDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.Shop_groupDetails.FETCH.SINGLE
};

export default {
  components: {
    NTable,
    ModalContainer,
    ShopGroupsSidewindow,

    AddShopGroup
  },
  data: function() {
    return {
      start: 0,

      selectedClickedShop_group: null,
      defaultConfig: defaultConfig,
      getDistributionShop_groupDetailsSelectable: getDistributionShop_groupDetailsSelectable
    };
  },
  mixins: [
    createFetchListMixin(ActionTypes.Shop_groupList.FETCH.ALL, 100, {
      advancedSearchable: false,
      searchable: false,
      scrollable: true
    }),
    createModalMixin("addShopGroup"),
    createLDTHost(LDTConfig)
  ],
  computed: {
    ...mapGetterObject(storeNS, shop_groupsDistributionGetters),
    tableConfig: function() {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40
      });
    },
    list: function() {
      console.log("Shop_Grops list ", this.shop_groupList?.shop_groups);
      return this.shop_groupList?.shop_groups || [];
    },
    headers: function() {
      return [
        createTableHeader("shop_groups_name", { fw: 700 }),
        createTableHeader("channel", { f: 0.5 }),
        createTableHeader("shop_group_type", { f: 0.5 }),
        createTableHeader("shops", { f: 2 }),
        createTableHeader("options", { text: false, mw: 40 })
      ];
    },
    filter: function() {
      return {
        ...this.metaFilter
      };
    },
    shopGroupsDetailsFlag: function() {
      return childOfOrEqualDetails(
        distributionShop_groupListLDTRoutes,
        this.$route
      );
    }
  },
  methods: {
    ...mapActionObject(storeNS, shop_groupsDistributionActions),

    selectedRow: function(shop_group) {
      // console.log("selectedRow ...", shop_group);
      return (
        this.selectedClickedShop_group &&
        this.selectedClickedShop_group["shop_group_id"] ==
          shop_group["shop_group_id"]
      );
    },

    defaultBasicFilter() {
      return {
        searchString: undefined
      };
    },

    onDialogCancelled: function() {
      closeModalRoute(this);
    },

    onAddShopGroupsClick: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_shop_group"
        }
      });
    },

    // refresh: function() {
    //   this.fetchListNext();
    // },

    onAddedShopGroup: async function(shop_group_id) {
      console.log("delete me tc ", shop_group_id, typeof shop_group_id);
      this.onDialogCancelled();
      this.fetchListReset();
      // this.refresh();
      await Shop_groupsService.getShopGroups({ start: this.start });
      await Shop_groupsService.fetchShopGruopDetailsTabOverview(shop_group_id);
      await Shop_groupsService.fetchShopGroupShopDetailsTabOverview(
        shop_group_id
      );
    },

    onShopGroupDelete: async function(item) {
      console.log("delete me tc ", item);
      const confirmationResult = await confirmDelete(
        "shop group",
        item.shop_group_name
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.Shop_groupList.DELETE.SINGLE](item);
      }
    },

    // Start Sidewindow
    onRowClicked: function(shop_group) {
      console.log("selected Clicked Shop_group ", shop_group);
      if (this.loadingFlag) {
        return;
      }
      this.selectedClickedShop_group = shop_group;
      this.$router.push({
        name: distributionShop_groupListLDTRoutes.names.tab,
        params: {
          shop_group_id: shop_group.shop_group_id,
          tab: "overview"
        }
      });
    },
    onCloseShopGroupsDetails: function() {
      this.selectedClickedShop_group = null;
      this.fetchListReset();
      handleFromRoute(this, () => {
        this.$router.push({
          name: distributionShop_groupListLDTRoutes.names.list
        });
      });
    }
  }
};
</script>

<style lang="scss">
.cmp-distribution-shop_groups-shop_group_list {
  .dt-page--body {
    --offset: 120px;
  }
}
</style>
